// extracted by mini-css-extract-plugin
export default {"fullScreenButton":"Koiy9WE827OQIN4hfWkM AisLsJaE_AWnIhDlnTUV"};